import React, {
  useContext,
  useState,
  useEffect,
  useRef,
} from 'react';
import ProductPageContext from '../../contexts/ProductPageContext';
import AddToBagButton from '../AddToBagButton/AddToBagButton';
import AppExclusiveButton from '../AppExclusiveButton/AppExclusiveButton';
import MemberEarlyAccessButton from '../MemberEarlyAccessButton/MemberEarlyAccessButton';
import StickySizeTray from './StickySizeTray';
import useMemberEarlyAccessCheck from '../../helpers/useMemberEarlyAccessCheck';

export default function StickyAddToBagManager({
  handleAddToBag,
  activeButtonLabel,
  primarySizeTileHandler,
  secondarySizeTileHandler,
  setSizeGuideOpen,
  atbLabelText,
}) {
  const ProductPageState = useContext(ProductPageContext);

  const {
    collectionData,
    tmntData,
  } = ProductPageState;

  const showMemberEarlyAccessButton = useMemberEarlyAccessCheck();

  const [stickySizeTrayVisible, setStickySizeTrayVisible] = useState(false);
  const [isOverlappingFooter, setIsOverlappingFooter] = useState(false);
  const stickyContainerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const footer = document.querySelector('#catalog-mfe-web-service-FooterFrontend');

      if (footer && stickyContainerRef.current) {
        const footerRect = footer.getBoundingClientRect();
        const stickyRect = stickyContainerRef.current.getBoundingClientRect();

        if (stickyRect.bottom > footerRect.top) {
          setIsOverlappingFooter(true);
        } else {
          setIsOverlappingFooter(false);
        }
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  if (collectionData.stickySizeSelectionCompleted && stickySizeTrayVisible) {
    setStickySizeTrayVisible(false);
    handleAddToBag();
  }

  const stickyAddToBagClick = () => {
    if (collectionData.hasQualifiedSku) {
      handleAddToBag();
    } else {
      setStickySizeTrayVisible(true);
    }
  };

  const stickyATBContainerStyle = isOverlappingFooter ? { visibility: 'hidden' } : { visibility: 'visible' };

  let actionButtonType = 'default';
  if (showMemberEarlyAccessButton) {
    actionButtonType = 'memberEarlyAccess';
  } else if (collectionData.activeProduct.isAppExclusive) {
    actionButtonType = 'appExclusive';
  }

  return (
    <>
      <div
        className="mfe-sticky-add-to-bag-container"
        data-testid="sticky-atb-container"
        style={{
          ...stickyATBContainerStyle,
        }}
      >
        {stickySizeTrayVisible ? (
          <StickySizeTray
            primarySizeTileHandler={primarySizeTileHandler}
            secondarySizeTileHandler={secondarySizeTileHandler}
            setSizeGuideOpen={setSizeGuideOpen}
            setStickySizeTrayVisible={setStickySizeTrayVisible}
          />
        ) : (
          <>
            {actionButtonType === 'memberEarlyAccess' && <MemberEarlyAccessButton />}
            {actionButtonType === 'appExclusive' && (
            <AppExclusiveButton
              brand={collectionData.activeProduct.brand}
              label={tmntData?.pdpOpenAppToShop?.value}
            />
            )}
            {actionButtonType === 'default' && (
            <AddToBagButton
              brand={collectionData.activeProduct.brand}
              label={atbLabelText}
              handleAddToBag={stickyAddToBagClick}
              activeButtonLabel={activeButtonLabel}
              isButtonDisabled={activeButtonLabel === 'addToBagSoldOut'}
              hasSelectableSoldOutSizeTiles={collectionData.hasSelectableSoldOutSizeTiles}
            />
            )}
          </>
        )}
      </div>
      <div
        className="mfe-sticky-add-to-bag-container"
        id="atb-shadow-sticky"
        data-testid="atb-shadow-sticky"
        ref={stickyContainerRef}
      />
    </>
  );
}
